import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=f2e9b9ac&scoped=true"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"
import style0 from "./Company.vue?vue&type=style&index=0&id=f2e9b9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e9b9ac",
  null
  
)

export default component.exports